<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ data?.heading | titlecase }}</span>
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <div class="py-4 px-8 table-bdr">
      <table>
        <tr>
          <th fxFlex="10%">Sr No</th>
          <th fxFlex="50%">Type of Charges</th>
          <th fxFlex="40%">Shipping Charges</th>
        </tr>
        <ng-container *ngFor="let price of priceArray; index as i">
          <tr *ngIf="price.key !== 'totalCharge'">
            <td fxFlex="10%">{{ i + 1 }}</td>
            <td fxFlex="50%">{{ price.key | PriceName }}</td>
            <td fxFlex="40%">
              {{
                price.key === "gstPercent"
                  ? price.value + "%"
                  : (price.value | RupeePaise: "rupee" | currency: "INR")
              }}
            </td>
          </tr>
        </ng-container>
        <ng-container *ngFor="let price of priceArray; index as i">
          <tr *ngIf="price.key === 'totalCharge'">
            <td fxFlex="10%"></td>
            <td fxFlex="60%" colspan="2" class="charge-title">Total Charge</td>
            <td fxFlex="40%" class="charge-title">
              {{ price.value | RupeePaise: "rupee" | currency: "INR" }}
            </td>
          </tr>
        </ng-container>
      </table>
    </div>
  </div>
</div>
